import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import HelpButton from "../../HelpButton";

export function SimpleTableDialogExplainSection({
  title,
  content,
}: {
  title: string;
  content: string;
}) {
  return (
    <Stack gap={2}>
      <Typography variant="subtitle1" sx={{ color: "text.primary" }}>
        {title}
      </Typography>
      <Typography
        variant="body1"
        sx={{ color: "text.secondary", whiteSpace: "pre-line" }}
      >
        {content}
      </Typography>
    </Stack>
  );
}

export function SimpleTableDialogTable({ records }: { records: string[][] }) {
  return (
    <TableContainer
      sx={{
        borderRadius: 0,
        "& .MuiTable-root": {
          "& .MuiTableCell-root": {
            borderBottom: "none",
          },
          tableLayout: "fixed",
          border: "1px solid #e0e0e0",
          "& .MuiTableRow-root": {
            "&:first-of-type,&:not(:last-of-type)": {
              borderBottom: "1px solid #e0e0e0",
            },

            "& .MuiTableCell-head": {
              p: "16px 0px",
              "&:not(:first-of-type)": {
                "& .MuiTypography-root": {
                  borderLeft: "1px solid #e0e0e0",
                },
              },
              "& .MuiTypography-root": {
                px: "16px",
              },
            },
            "& .MuiTableCell-body": {
              "&:not(:first-of-type)": {
                borderLeft: "1px solid #e0e0e0",
              },
            },
          },
        },
      }}
    >
      <Table>
        <TableHead>
          <TableRow>
            {records[0].map((r, i) => (
              <TableCell key={i}>
                <Typography variant="subtitle2" color="text.primary">
                  {r}
                </Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {records.slice(1).map((r, i) => (
            <TableRow key={i}>
              {r.map((c, i) => (
                <TableCell key={i}>
                  <Typography variant="body2" color="text.primary">
                    {c}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function SimpleTableDialogTableSection({
  title,
  records,
}: {
  title: string;
  records: string[][];
}) {
  return (
    <Stack gap={2}>
      <Typography variant="subtitle1" sx={{ color: "text.primary" }}>
        {title}
      </Typography>
      <SimpleTableDialogTable records={records} />
    </Stack>
  );
}

export function SimpleTableDialogReference({ children }: { children: string }) {
  return (
    <Stack>
      <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
        参考：
      </Typography>
      <Typography variant="caption" sx={{ color: "text.secondary" }}>
        {children}
      </Typography>
    </Stack>
  );
}

export default function SimpleTableHelpDialog({
  title,
  explain,
  table,
  reference,
}: {
  title: string;
  explain: { title: string; content: string };
  table: { title: string; records: string[][] };
  reference: string;
}) {
  return (
    <HelpButton dialogTitle={title}>
      <Stack gap={6}>
        <SimpleTableDialogExplainSection {...explain} />
        <SimpleTableDialogTableSection {...table} />
        <SimpleTableDialogReference>{reference}</SimpleTableDialogReference>
      </Stack>
    </HelpButton>
  );
}
